import styled from 'styled-components';

export const StyledCompanyCiUpload = styled.div<{ $isView: boolean }>`
  .ccu-wrapper {
    &-top {
      ${({ $isView }) => $isView && 'display: none;'}
      margin-bottom: 20px;

      > div {
        width: 100%;
      }

      &-upload {
        height: 40px;
        width: 100%;
        background-color: #ffffff;
        border: 1px solid #dadada;
        border-radius: 6px;
        box-shadow: none;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;

        > span {
          font-size: 14px;
          font-weight: 400;
          line-height: 21px;
          color: #adadad;
          text-transform: math-auto;
        }
      }
    }

    &-middle {
      &-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #dadada;
        border-radius: 6px 6px 0px 0px;
        background: #f8f8f8;
        ${({ $isView }) => $isView && 'display: none;'}

        &-left {
          display: flex;
          align-items: center;
          gap: 8px;

          > p {
            white-space: nowrap;
          }
        }

        &-right {
          width: 206px;
          text-align: center;
        }
      }

      &-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #dadada;
        border-top: none;
        padding: 19px 0;
        border-radius: 0px 0px 6px 6px;
        background: #ffffff;
        ${({ $isView }) =>
          $isView && 'border-top: 1px solid #dadada; border-radius: 6px; padding-right: 16px;'}

        &-left {
          display: flex;
          align-items: center;
          gap: 8px;
          ${({ $isView }) => $isView && 'padding-left: 16px;'}

          > span {
            white-space: nowrap;
          }

          > img {
            width: 58px;
            height: 42px;
          }

          > p {
            color: #585959;
            font-size: 14px;
            font-weight: 400;
            line-height: 18px;
            text-align: left;

            > span {
              display: inline-block;
              margin-left: 8px;
              color: #adadad;
            }
          }
        }

        &-right {
          width: 206px;
          text-align: center;
          color: #585959;
          ${({ $isView }) => $isView && 'width: 24px;'}

          > img {
            width: 24px;
            height: 24px;
          }
        }
      }
    }

    .delete-btn {
      width: 19px;
      min-width: 19px;
      height: 19px;
      border-radius: 50%;
      box-shadow: none;
      background: #ececec;
      padding: 0;
      margin: 10px 14px 10px 16px;

      > img {
        width: 14px;
        height: 14px;
      }
    }
  }
`;
